import { component } from 'picoapp';
import { clear } from 'utils/clear';
import stringMemory from 'utils/string-memory';

export default component(async (node, ctx) => {
  const {
    sectionId, productId, baseUrl, limit,
  } = node.dataset;

  const fetchRecommendations = async () => {
    const params = new URLSearchParams({
      section_id: sectionId,
      product_id: productId,
      intent: 'related',
      limit,
    });

    const response = await fetch(`${baseUrl}?${params}`);

    if (response.status >= 200 && response.status < 300) {
      return response.text();
    }

    throw new Error(`Could not fetch product recommendations. Server responded with: ${response.status}`);
  };

  const initRecommendations = async () => {
    try {
      const memory = stringMemory(sessionStorage);
      const response = await memory.get(`product-recommendations-${productId}`, fetchRecommendations);

      const container = document.createElement('div');
      container.innerHTML = response;

      clear(node);
      node.insertAdjacentHTML(
        'beforeend',
        container.querySelector('[data-component]').innerHTML,
      );

      ctx.emit('app:remount');
      container.remove();
    } catch (e) {
      node.remove();

      throw e;
    }
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        observer.disconnect();

        initRecommendations();
      }
    });
  }, { rootMargin: '100px' });

  observer.observe(node);
});
